import { IActionCreatorAsync } from "core/actions/Actions.interfaces";
import { ILicense } from "reducers/Reducers.interfaces";
import { IlicenseCard } from "../Tenant.types";

export interface licenseFormProps {
  dataSource:Array<IlicenseCard>
  title: any
  onCancelClick: (id:string | null, data: any)=>void
  updateLicenseByApp: IActionCreatorAsync
  createLicenseAllocationUpdateEvent: IActionCreatorAsync
  context: string
  id: any
  license?: ILicense
  app_code: string
  partnerAccountId?: string
  type: string
}

export enum LicenseFormActions {
  NO_CHANGE = 'no-change',
  ADD = 'add',
  SUBTRACT = 'subtract',
  RESET = 'reset'
}